import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';

import { Env } from '@bloomays-lib/types.shared';

import App from './app/app';
import { initMonit } from './helpers/monitoring';
import { Logger } from './services/service-logger';

const { VITE_AUTH0_DOMAIN, VITE_APP_CLIENT_AUTH0_CLIENT_ID, VITE_BLOOMERS_API, VITE_ENV, MODE } = import.meta.env;
const audience = VITE_BLOOMERS_API;
const domain = VITE_AUTH0_DOMAIN;
const clientId = VITE_APP_CLIENT_AUTH0_CLIENT_ID;
const env: Env = VITE_ENV;
if (env === 'production' || env === 'staging' || env === 'development') {
  const tagManagerArgs = {
    gtmId: 'GTM-WH3XTD4Z',
  };
  TagManager.initialize(tagManagerArgs);
}

const logger = Logger('Main');
initMonit(logger);
logger.info('Load App Client', { mode: MODE });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <App auth0ProviderConfig={{ domain, clientId, audience }} env={env} />
  </StrictMode>,
);
